const registry: Map<string, unknown> = new Map()
const createRegistryKey = (namespace: string, id: string) => [namespace, id].join('::')

export const createUnique = <T>(namespace: string, id: string, v: T) => {
  if (registry.has(createRegistryKey(namespace, id))) {
    throw new Error(`The ${namespace || 'key'} "${id}" is already registered`)
  }

  return v
}
